'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timeline = require('./view/timeline.js');

var _timeline2 = _interopRequireDefault(_timeline);

var _timelineItem = require('./view/timeline-item.js');

var _timelineItem2 = _interopRequireDefault(_timelineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_timeline2['default'].Item = _timelineItem2['default'];

exports['default'] = _timeline2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-timeline/lib/index.js
// module id = 477
// module chunks = 0